/*
 * @Plugin name: JFTabs
 * @Author: Vaibhav.shringarpure for Jellyfish 
 * @Date: 2019-01-24 11:50:00 
 * @config parameters : toggleTabLink, activeClassName, tabContainer
 * @required Hooks : All Tab links MUST have 'data-tab' attribute and all Tab Contents MUST have 'data-tabcontent' attribute for it to work
 * @usage: $('.tab-trigger').JFtabs({toggleTabLink: true, activeClassName: 'selected'});
 */
(function ($) {
  'use strict';

  $.fn.jfTabs = function (options) {

    //Configuration 
    const config = $.extend({
      toggleTabLink: false,
      firstTabActive: false,
      activeClassName: 'active',
      tabContainer: $('[data-tabcontainer]'),
    }, options);
  
    const tabContent = $(config.tabContainer).find('[data-tabcontent]');
    
    //To make first Tab and its respective content tab to have
    const firstTabActive = function(element) {
      $(element).each(function (i, el) {
        if (i === 0) {
          // Will be done to first tablink
          $(el).addClass('active');
        }
      });
    }


    // This is the element on which the plugin is attached to in this case its the tablink
    return this.each(function () {
      const self = $(this);

      //Finds the Tab Triggers inside the same tabContainer as the one which is clicked on
      //  This is to account for multiple tab modules used on a page
      const tabTrigger = $(self).closest(config.tabContainer).find('[data-tab]');
      
      //Giving the first Tab link and first tab content active class by default
      if(config.firstTabActive) {
        //First Tab Link
        firstTabActive(tabTrigger);

        //First Tab Content
        firstTabActive(tabContent);
      }
     
      //Adding Click event handler to the tab
      self.on('click', function (e) {
        e.preventDefault();
        const clickedTabLinkAttribute = $(self).data('tab');
        
        tabTrigger.not(self).removeClass('active');
        if (config.toggleTabLink) {
          $(self).toggleClass('active');
        } else {
          $(self).addClass('active');
        }

        // Start of TabContent
        const tabContents = $(self).closest(config.tabContainer).find('[data-tabcontent]');
        const selectedTabContent = tabContents.filter(function (index, currentValue, arr) {
          return currentValue.dataset['tabcontent'] === clickedTabLinkAttribute;
        });

        tabContents.not(selectedTabContent).removeClass('active');
        if (config.toggleTabLink) {
          selectedTabContent.toggleClass('active');
        } else {
          selectedTabContent.addClass('active');
        }
      }); // End of Tablinks
    });
  };
}(jQuery));